import React, { useState, useMemo, useRef, useEffect, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeUsersRole, removeUserFromDeviceManagement, getDeviceEvents } from "../../../store/service-actions";
import { getDeviceUsers } from "../../../store/service-actions";
import classes from './SiteView.module.css';
import AppView from "../../UI/Pin/AppView/AppView";
import ContorlsBar from "../../UI/ControlsBar/ControlsBarV2/ControlsBarV2";
import Logs from "../../sub-components/Logs/Logs";
import { defer, Link, useLoaderData } from "react-router-dom";
import { serviceActions } from "../../../store/service-Slice";
import GroupsGrid from "../../GridList/GroupsGrid";
import { getDeviceEventLogsRanged, getSingleDeviceData, getSingleDeviceUsers, changeRole, removeUser, inviteUser, getInputRules, getSchedules, getCamectsAPI, getHolidaysModesAPI, getSigFoxSensorsAPI, suspendDevice, clearDeviceLogs, getGroups, addSitesToGroup, changeCamectIntegration, rebootIPIODevice, resetIPIODevice, doesSupportCamect, checkSiteConfig, getAdvRules, getSiteByUUID, getVirtualRelationshipsAPI, getSiteAccessRestrictions, getIntegrations, getLiveViewCameras, getDavantisesAPI, getTankSensorsForSite } from "../../../Api Methods/Api";
import Modal from "../../Modal/Modal";
import { UseConvertZonedDateTime, UseParseNaiveDateTime } from "../../hooks/UseConvertZonedDateTime";
import HandleResponseData from "../../../hooks/HandleResponseData";
import SingleDeviceUsersTableLayout from "../../UI/Table/SingleDeviceUsersTableLayout";
import { Await, useNavigate, useRevalidator } from 'react-router'
import { Oval } from "react-loading-icons";
import Automations from "../../UI/Cards/Automations/Automations";
import VirtualSources from "../../UI/Cards/Automations/VirutalSources/VirtualSources";
import AnalyticsPage from "../../sub-components/Analytics/Analytics";
import { useSocketHook } from "../../../Socket/useSocketHook";
import parsePinStates from "../../../Socket/parsePinStates";
import { authActions } from "../../../store/auth-Slice";
import DropdownList from "../../UI/Cards/DropdownList";
import SuspendIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/suspend.png'
import ClearLogsIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/clearLogs.png'
import ChangePortalNameIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/changeTag.png'
import AddToGroupIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/addToGroup.png'

import CamectIntegrationIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/camectIntegration.png'
import CopyConfigIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/copyConfig.png'
import RebootIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/reboot.png'
import ResetIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/reset.png'
import settingsIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Admin - Settings.svg'
import DropDownForm from "../../forms/DropDownForm";
import check from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import serialIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/serial.png'

import fail from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import areYouSure from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/confirmation.png'
import Button1 from "../../UI/Button/Button1";
import SetTag from "../../Modal/ModalLayouts/SetTag";
import DataManager from "../../../hooks/DataManager";
import ChangeGroup from "../../Modal/ModalLayouts/ChangeGroup";
import { socket } from "../../../Socket/socket";
import ChangeSiteName from "../../Modal/ModalLayouts/ChangeSiteName";
import Overview from "../../sub-components/Overview/Overview";
import SetSerial from "../../Modal/ModalLayouts/SetSerial";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { act } from "react";
import CopySiteConfigForm from "../../forms/CopySiteConfigForm";
import Lottie from "lottie-react";
import failAnim from '../../../assets/animations/fail.json'
import areYouSureAnim from '../../../assets/animations/areYouSure.json'
import successAnim from '../../../assets/animations/success.json'

const SiteView = () => {
    const { SiteData, SiteEventLogs, SiteDeviceUserList, RulesPreloadData, VirtualSourcesPreloadData } = useLoaderData();

    useEffect(() => {
        if (SiteData.isError) {
            return SiteData.message;
        }
        if (SiteDeviceUserList.isError) {
        }

    }, [SiteData, SiteEventLogs, SiteDeviceUserList])

    const dispatch = useDispatch();
    useEffect(() => {
        const sesstionDeviceUUID = localStorage.getItem("DeviceUUID");
        dispatch(authActions.updateDeviceUUID(sesstionDeviceUUID));
    }, [dispatch]);

    const [parsedSiteData, setParsedSiteData] = useState(SiteData);
    const [hasDeviceChanged, setHasDeviceChanged] = useState(0);
    const SASiteData = useSelector(state => state.service.SiteData)
    const [siteData, setSiteData] = useState(HandleResponseData(parsedSiteData))
    const [addToGroupVisible, setAddToGroupVisible] = useState(false)
    const [selectedNewGroup, setSelectedNewGroup] = useState(null)

    const [copyConfigVisible, setCopyConfigVisible] = useState(false)

    useEffect(() => {

        if (SASiteData == null || SASiteData == undefined) {
            //setSiteData(HandleResponseData(SASiteData))
            dispatch(serviceActions.setSiteData(SiteData.data[0]))
        }

    }, [dispatch, SASiteData])

    useEffect(() => {
        dispatch(serviceActions.setSiteData(SiteData.data[0]))
        socket.emit("routeCommand", {
            cmd: "getStates",
            uuid: DeviceUUID
        })
    }, [])

    const dataManager = new DataManager();
    const firmware = siteData[1].firmware
    const firmwareMajor = firmware[0]
    const firmwareMinor = firmware[1]
    const DeviceType = siteData[1].type;
    const isOnline = siteData[1].online == "YES" ? true : false;
    const status = siteData[1].status
    const userCount = SiteData.data[0].userCount
    const camectIntegationType = siteData[1].camectIntegrationType;
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const userID = useSelector(state => state.auth.userID);
    const userRole = useSelector(state => state.auth.role);
    const companyName = useSelector(state => state.auth.companyName);
    // RE:SURE and its subgroups have a hardcoded 100,000 CCTV licences on the backend so they
    // never hit linking issues - mirrors the showCamect check in GroupSites.js/Dashboard.js.
    const myGroupPath = (() => {
        try { return JSON.parse(localStorage.getItem('groups') || '[]').find(g => g.name === companyName)?.groupPath || ''; }
        catch { return ''; }
    })();
    const isRESUREGroup = companyName === "RE:SURE" || myGroupPath.includes("RE:SURE");
    const deviceId = siteData[1].id;
    const deviceTag = siteData[1].tag;
    const uipioid = siteData[1].key;
    const userEmail = useSelector(state => state.auth.email);
    const [deviceData, setDeviceData] = useState(siteData[0]);
    const [deviceEventsList, setDeviceEventsList] = useState(SiteEventLogs);
    const [deviceUserList, setDeviceUsersList] = useState(SiteDeviceUserList);
    const apiData = { token, client }
    const CamectIntegationType = useSelector(state => state.service.CamectIntegationType);
    const [activeTable, setActiveTable] = useState(() => {
        const savedAnalyticsState = sessionStorage.getItem('analyticsState');
        return savedAnalyticsState ? "Analytics" : "Overview";
    });
    const [leftCollapsed, setLeftCollapsed] = useState(localStorage.getItem('appViewCollapsed') === 'true');
    const DeviceId = siteData[1].id
    const DeviceUUID = siteData[1].uuid;
    const scheduleOnly = siteData[1].scheduleOnly || 0
    const liveViewEnabled = siteData[1].liveViewEnabled || 0
    const DeviceEvents = useSelector(state => state.service.singleDeviceEvents);
    const [refreshTable, setRefreshTable] = useState(false);
    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()
    const ModalDialog = useRef();
    // RulesPreloadData/VirtualSourcesPreloadData are promises created once by this route's
    // loader and never re-fetched while this SiteView instance is mounted. Switching tabs
    // unmounts/remounts Automations & VirtualSources (see renderTable below), and their own
    // mount effects prefer preloadedData over a live fetch - so without this, returning to the
    // tab after e.g. deleting a rule re-hydrates from that same stale, already-resolved promise.
    // Only hand over the preload the first time each tab is shown; every time after that, pass
    // null so those components fall through to their own live-fetch path instead.
    const rulesPreloadConsumedRef = useRef(false);
    const virtualSourcesPreloadConsumedRef = useRef(false);
    const [prevTableID, setPrevTableID] = useState(() => {
        const savedAnalyticsState = sessionStorage.getItem('analyticsState');
        return savedAnalyticsState ? "Analytics" : "Overview";
    })
    const [update, setUpdate] = useState(0)
    const [selectedGroup, setSelectedGroup] = useState()
    const [groups, setGroups] = useState([]);
    const [pinEdited, setPinEdited] = useState(false)
    const [pendingActive, setPendingActive] = useState(false)

    const revalidator = useRevalidator();

    const [showChangeGroup, setShowChangeGroup] = useState(false)
    const [showChangeCCTV, setShowChangeCCTV] = useState(false)
    const [showChangeName, setShowChangeName] = useState(false)
    const [showChangeSerialNumber, setShowChangeSerialNumber] = useState(false)
    const [showChangePortalName, setShowChangePortalName] = useState(false)
    const [showSuspendSite, setShowSuspendSite] = useState(false)

    const [_supportsCamect, _setSupportsCamect] = useState(0)

    const [linkedTo, setLinkedTo] = useState(null)
    const [uuids, setUuids] = useState([])
    const [updateLinkedTo, setUpdateLinkedto] = useState(0)

    const [activeHolidayModes, setActiveHolidayModes] = useState([])
    const [schedules, setSchedules] = useState([])

    const [pinIntegrations, setPinIntegrations] = useState([])

    const [hasGateways, setHasGateways] = useState(false);
    const [gatewayImei, setGatewayImei] = useState(null);

    const portalName = deviceTag !== "" ? `${deviceTag} - ${uipioid}` : uipioid
    const [siteGroupID, setSiteGroupID] = useState(null)


    const navigate = useNavigate();
    const handleCollapseAppView = () => {
        setLeftCollapsed(!leftCollapsed)
    }

    useEffect(() => {
        localStorage.setItem('appViewCollapsed', leftCollapsed)
    }, [leftCollapsed])


    const checkCamectSupport = async () => {
            const supportsCamect = await checkSiteConfig(apiData, DeviceId, dispatch)
            _setSupportsCamect(supportsCamect[0].supportsCamect)
        }

    const checkHasLinkToAnotherSite = async () => {
            const response = await getAdvRules(apiData, DeviceUUID)
            if (response.success) {
                const rules = response.data.rules
                const siteIDs = await extractRuleSites(rules)

                console.log(siteIDs);
                setLinkedTo(siteIDs)
            }
     }

    // mode.start/mode.end are naive 'YYYY-MM-DD HH:MM:SS' wall-clock strings in mode.timezone,
    // not UTC - they must be converted into the viewer's own timezone before being parsed,
    // otherwise the comparison silently shifts by the difference between the two zones.
    const filterActiveHolidayModes = (holidayModes) => {
        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const now = new Date();
        return (holidayModes || []).filter((mode) => {
            if (!mode?.active) return false;
            const start = UseParseNaiveDateTime(UseConvertZonedDateTime(mode.start, mode.timezone, browserTimeZone));
            const end = UseParseNaiveDateTime(UseConvertZonedDateTime(mode.end, mode.timezone, browserTimeZone));
            return now >= start && now <= end;
        });
    }

    const checkActiveHolidayModes = async () => {
        const holidayModes = await getHolidaysModesAPI(apiData, DeviceUUID)
        setActiveHolidayModes(filterActiveHolidayModes(holidayModes))
    }

    useEffect(() => {
        checkCamectSupport();
        checkHasLinkToAnotherSite();
    }, [])

    useEffect(() => {
        if (updateLinkedTo > 0) {
            checkHasLinkToAnotherSite();
            checkActiveHolidayModes();
        }
    }, [updateLinkedTo])

    // Derives which temporary schedules (holiday modes) are currently in effect right now
    // from the already in-flight RulesPreloadData promise - no extra network request.
    useEffect(() => {
        let cancelled = false;

        RulesPreloadData.then((data) => {
            if (cancelled) return;
            setActiveHolidayModes(filterActiveHolidayModes(data?.holidayModesRes));
            setSchedules(data?.schedulesRes?.data ?? []);
        });

        return () => { cancelled = true; };
    }, [])

    // Derives which output pins are linked to a CCTV/virtual integration (Dahua, Hikvision, etc.)
    // from the already in-flight VirtualSourcesPreloadData promise - no extra network request.
    useEffect(() => {
        let cancelled = false;

        VirtualSourcesPreloadData.then((data) => {
            if (cancelled) return;
            setPinIntegrations(data?.integrationsRes || []);
        });

        return () => { cancelled = true; };
    }, [])


    const extractRuleSites = async (rules) => {
        const sites = new Map();

        for (const ruleObj of rules) {

            // Rule owner
            const ownerUuid = ruleObj.rule?.site_owner;
            if (ownerUuid && ownerUuid !== DeviceUUID && !sites.has(ownerUuid)) {
                const response = await getSiteByUUID(apiData, ownerUuid, dispatch);
                if (response.success) {
                    sites.set(ownerUuid, {
                        siteId: response.data.key,
                        siteName: response.data.tag,
                        type: "controlled"
                    });
                }
            }

            // Actions
            for (const action of ruleObj.actions ?? []) {
                const targetUuid = action.site_to;
                console.log(ruleObj);
                console.log(action);
                if (targetUuid && targetUuid !== DeviceUUID && !sites.has(targetUuid) && ruleObj.rule.site_owner == DeviceUUID) {
                    const response = await getSiteByUUID(apiData, targetUuid, dispatch);
                    if (response.success) {
                        sites.set(targetUuid, {
                            siteId: response.data.key,
                            siteName: response.data.tag,
                            type: "controller"
                        });
                    }
                }
            }
        }

        return Array.from(sites, ([uuid, { siteId, siteName, type }]) => ({
            uuid,
            siteId,
            siteName,
            type
        }));

    };




    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            setGroups(listOptions || []);
        
            const groupObject = listOptions.find(group => group.name === siteData[1].name)
            setSiteGroupID(groupObject?.id ?? null)
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    };

    useEffect(() => {
        // if (pinEdited){
        //     window.location.reload();
        // }

    }, [pinEdited])

    useEffect(() => {
        GetGroups();
    }, []);

    useEffect(() => {
        if (hasDeviceChanged == 0) return;

        const fetchData = async () => {
            const SingleDeviceData = await getSingleDeviceData(apiData, DeviceUUID);            //setParsedSiteData(SingleDeviceData);
            //setSiteData(SingleDeviceData)
            setParsedSiteData(SingleDeviceData)
            //revalidator.revalidate(); 
        };

        fetchData();
    }, [hasDeviceChanged]);


    //Get array of pinNames
    const outputs = siteData[0].OutputPins.map((Output) => {
        const { pinName, Pin, pinStatusOn, pinStatusOff, type, ...rest } = Output;
        return Output
    })

    // check if device has no inputs if not then skip
    let inputs = []
    if (siteData[1].numInput != 0) {
        inputs = siteData[0].InputPins.map((Input) => {
            const { pinName, Pin, pinStatusOn, pinStatusOff, type, DeviceUUID, ...rest } = Input;
            return Input
        })
    }

    let DeviceName = siteData[1].tag != "" ? siteData[1].tag : siteData[1].deviceName
    if (DeviceName == "" || DeviceName == null) {
        DeviceName = uipioid
    }

    const isSocketConnected = useSelector(state => state.service.isSocketConnected);
    const [socketPinStates, setSocketPinStates] = useState();

    const HandleCheckUUID = (data) => {
        if (deviceUUID === data.uuid) {
            const pinStates = parsePinStates(data);
            setSocketPinStates(pinStates)
        }
    };

    const deviceChanged = (hasDeviceChanged) => {
        if (deviceUUID === hasDeviceChanged.uuid) {
            setHasDeviceChanged(hasDeviceChanged + 1);
        }
    }
    const socketListeners = [
        { socketlistener: "appPinStates", callback: HandleCheckUUID },
        { socketlistener: "deviceChanged", callback: deviceChanged }
    ];

    useSocketHook(isSocketConnected, socketListeners);


    useEffect(() => {
        if (isSocketConnected) {
            socket.emit("app")
        }
    }, [isSocketConnected])

    const AddSiteToGroup = async (uuid) => {

        let body = {
            groupID: selectedNewGroup.id,
            groupName: selectedNewGroup.name,
            groupDevices: [uuid]
        }
        setAddToGroupVisible(false)
        const response = await addSitesToGroup(apiData, body, dispatch);
        if (response.success) {
            HandleCloseModal();
            successModal("Site successfully added to group: " + selectedNewGroup.name, false);
            //dispatch(GetSingleDeviceData(DeviceUUID, apiData));
            siteData[1].name = selectedNewGroup.name
            dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));
        } else {
            errorModal("Failed to add site to group, please try again", false);
        }

    }


    const resetSite = async (apiData, DeviceUUID, userID, DeviceName, dispatch) => {
        const response = await resetIPIODevice(apiData, DeviceUUID, userID, DeviceName, dataManager.getItem('changePortalGroupForReset'), dispatch)
        if (response.success) {
            //update data here?
            if (dataManager.getItem('changePortalGroupForReset') !== "") {
                siteData[1].name = dataManager.getItem('changePortalGroupForReset')
            }
            // siteData[1].tag = ""
            // siteData[1].deviceName = ""
            // siteData[1].active = 0
            // dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));

            //hard refresh instead 

            siteResetSuccessModal("Site reset successfully!", false)

        }
    }

    const HandleRefreshPage = () => {
        HandleCloseModal()
        window.location.reload();
    }

    localStorage.setItem('DeviceID', deviceId);
    localStorage.setItem('DeviceName', DeviceName);

    const successModal = (message) => {
        setModalTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Button icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity="secondary"/>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const siteResetSuccessModal = (message) => {
        setModalTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                    <br/>
                    <p style={{ textAlign: "center", color: "#858585" }}>Page will reload for changes to take effect</p>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Button icon="pi pi-times" onClick={HandleRefreshPage} label="Close" severity="secondary"/>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const HandleReloadData = () => {
        HandleCloseModal()
        window.location.reload();
    }

    const camectIntegrationChangedModal = (message) => {
        setModalTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
               <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                    <br></br>
                    <p style={{ textAlign: "center", color: "#858585" }}>Page will have to reload for changes to take effect</p>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Button icon="pi pi-sync"  onClick={HandleReloadData} label="Reload" severity='secondary'/>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const errorModal = (message, isCopyConfig) => {
        setModalTitle('Error')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Button icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity="secondary"/>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const confirmModal = () => {
        setModalTitle('Warning')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.Icon} src={areYouSure}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{`Changing integration type will reset current output/input links, \nare you sure you want to continue?`}</h3>
                    <p style={{ textAlign: "center", color: "#858585", fontWeight: "500" }}>Please note, if you are linking this camect using the mobile app,</p>
                    <p style={{ textAlign: "center", color: "#858585", fontWeight: "500" }}>you will need to exit and re-enter the site for this change to take effect</p>
                </div>
                <br></br>
                <br></br>
                <div>

                    <Button icon="pi pi-times" onClick={HandleCloseModal} label="Cancel" severity='secondary'/>
                    <br/>
                    <Button icon="pi pi-check" onClick={Changecamectintergrationtype} label="Continue" severity='success'/>
                </div>
            </div>
        )
        HandleShowModal();
    }

    // const ShowGroupsModal = async () => {
    //     console.log(groups)
    //     setAddToGroupVisible(true)
    //     //const groupNames = groups.map(listOptions => listOptions.name).sort((a, b) => a.localeCompare(b));;
    //     //HandleCloseModal()
    //     //setModalTitle("Add site to group")
    //     // setModalComponent(
    //     //     <div>
    //     //         <Dropdown label={"Please select a group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />
    //     //         <br></br>
    //     //         <Button1 onClick={() => AddSiteToGroup(DeviceUUID)}>Add to group</Button1>
    //     //     </div>

    //     // )
    //     // HandleShowModal();
    // }

    const Changecamectintergrationtype = async () => {
        HandleCloseModal();
        const CamectIntegationType = siteData[1].camectIntegrationType == 2 ? 1 : 2;
        const notificationMessage = CamectIntegationType == 1 ? "Whole Camect" : "Per Cam Arming"
        const response = await changeCamectIntegration(apiData, DeviceUUID, CamectIntegationType, DeviceName, dispatch)
        if (response) {
            camectIntegrationChangedModal("CCTV integration changed to " + notificationMessage)
            siteData[1].camectIntegrationType = CamectIntegationType
            dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));
        } else {
            errorModal("Failed to change CCTV integration type, please try again")
        }
    }

    const suspendSite = async () => {
        const suspend = siteData[1].status == "suspended" ? "available" : "suspended";
        const response = await suspendDevice(apiData, suspend, DeviceId, dispatch);
        if (response) {
            HandleCloseModal();
            let status;

            if (siteData[1].status === "suspended") {
                status = "available"
            } else {
                status = "suspended"
            }
            successModal("Site is now " + status)
            siteData[1].status = suspend
            dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));
        } else {
            errorModal("Something went wrong, please try again", false)
        }
    }

    const ChangeTag = () => {
        setModalTitle("Change portal name")
        setModalComponent(
            <SetTag
                placeholder={siteData[1].tag}
                DeviceUUID={DeviceUUID}
                HandleCloseModal={HandleCloseModal}
                dispatch={dispatch}
                update={update}
                setUpdate={setUpdate}
                siteData={siteData}
                setSiteData={setSiteData}
                successModal={successModal}
                errorModal={errorModal}
                reloadOnSuccess={true}
                pendingActive={pendingActive}
                setPendingActive={setPendingActive}
            />)
        HandleShowModal()
    }

    const ChangeSerial = () => {
        setModalTitle("Set serial number")
        setModalComponent(
            <SetSerial
                placeholder={siteData[1].subGroup}
                DeviceUUID={DeviceUUID}
                HandleCloseModal={HandleCloseModal}
                dispatch={dispatch}
                update={update}
                setUpdate={setUpdate}
                siteData={siteData}
                setSiteData={setSiteData}
                successModal={successModal}
                errorModal={errorModal}
            />
        )
        HandleShowModal()
    }

    const showChangeNameModal = () => {
        setModalTitle("Change app site name for all users")
        setModalComponent(
            <ChangeSiteName
                placeholder={siteData[1].deviceName}
                DeviceUUID={DeviceUUID}
                deviceID={DeviceId}
                HandleCloseModal={HandleCloseModal}
                dispatch={dispatch}
                update={update}
                setUpdate={setUpdate}
                siteData={siteData}
                setSiteData={setSiteData}
                successModal={successModal}
                errorModal={errorModal}
            />)

        HandleShowModal();
    }

    const handleItemClick = async (item) => {
        switch (item.title) {
            case 'Unsuspend site':
            case 'Suspend site':
                suspendSite()
                break;
            case 'Clear logs':
                const HandleClearLogs = async () => {
                    const response = await clearDeviceLogs(apiData, DeviceUUID, userID, dispatch);
                    if (response.success) {
                        HandleCloseModal();

                        successModal("Logs cleared successfully", false)
                    } else {
                        errorModal("Something went wrong, please try again", false)
                    }
                }

                HandleCloseModal(); //Close the current settings modal
                setModalTitle("Clear Logs");
                 setModalComponent(
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                gap: "20px"
                              }}
                            >
                             <div
                                style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems:"center",
                                flexDirection: "column",
                                width: "100%",
                                gap: "3px"
                                }}
                            >

                                <Lottie
                                    animationData={areYouSureAnim}
                                    loop={false}
                                    style={{ width: 150, height: 150, margin: "0px" }}
                                />
                                <br/>

                                <h3 style={{ fontSize:"20px", textAlign: "center", color: "#858585", marginBottom:"15px" }}>{"Are you sure you want to clear all logs?"}</h3>
                                <h4 style={{  fontSize:"18px",textAlign: "center", margin: "0px", color: "red" }}>This action is permanent!</h4>
                                
                            </div>
          
                          
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                  gap: "10px"
                                }}
                              >
                                <Button icon="pi pi-times"  label="Cancel" severity="secondary" onClick={HandleCloseModal} />
                                <Button
                                  icon="pi pi-trash" 
                                  onClick={() => HandleClearLogs()}
                                  label="Yes, clear logs"
                                  severity="danger"
                                />
                              </div>
                            </div>
                          );
                HandleShowModal()
                break;
            case 'Change portal name':
                HandleCloseModal();

                ChangeTag();
                break;

            case 'Change serial number':
                HandleCloseModal();

                ChangeSerial();
                break;

            case "Change app site name (Global)":

                showChangeNameModal();
                break;
            case 'Add to group':
                //ShowGroupsModal();
                setAddToGroupVisible(true)
                break;
            case 'Change CCTV integration type':
                //HERE123
                confirmModal()

                //Changecamectintergrationtype();
                break;
            case 'Reset site':
                const ResetSite = () => {
                    HandleCloseModal()
                    setModalTitle("Are you sure?")
                    setModalComponent(
                          <div style={{display:"flex", flexDirection:"column", alignContent:"center", alignItems:"center"}}>

                            <Lottie
                                animationData={areYouSureAnim}
                                loop={false}
                                style={{ width: 150, height: 150, margin: "0px" }}
                            />
                        <br/>
                        <div style={{ textAlign: "center" }}>
                            <h3 style={{ fontSize:"20px", textAlign: "center", color: "#858585", marginBottom:"8px" }}>Are you sure you want to reset this site?</h3>
                        </div>
                        <p style={{ fontSize:"14px", textAlign: "center", color: "#858585", marginBottom:"5px" }}>This will revert all settings & customisations to factory default.</p>
                        <p style={{ fontSize:"18px", textAlign: "center", color: "#fc4444", marginBottom:"15px" }}>This action cannot be undone!</p>

                            <br></br>
                            <ChangeGroup
                                apiData={apiData}
                                DeviceUUID={""}
                                companyName={""}
                                NotificationTitle={""}
                                label={"To change group, please select a new group below"}
                                dropDownOptions={groups.map(group => group.name).sort((a, b) => a.localeCompare(b))}
                                HandleCloseModal={HandleCloseModal}
                                update={update}
                                setUpdate={setUpdate}
                                SiteDevices={[]}
                                setSiteDevices={[]}
                            />
                            <br></br>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "10px" // Adds space between buttons
                            }}>
                              
                                <Button icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
                                <Button icon="pi pi-refresh" onClick={() => resetSite(apiData, DeviceUUID, userID, DeviceName, dispatch)} label="Yes, I'm sure" severity='danger'/>
                            </div>
                        </div>
                    )

                    HandleShowModal();
                }

                ResetSite();
                break;
            case 'Reboot site':
                const RebootDevice = async () => {
                    const response = await rebootIPIODevice(apiData, DeviceUUID, userID, DeviceName);
                    if (response) {
                        successModal("Site rebooting...")
                    } else {
                        errorModal("Failed to reboot site, please try again")
                    }
                }

                RebootDevice();
                break;
            case 'Copy site configuration': 
                HandleCloseModal();
                setCopyConfigVisible(true)
                break;
                default:
                break;
        }
    };

    const tableNameHandler = (tableId) => {
        if (tableId !== "Config") {
            setPrevTableID(tableId)
            setActiveTable(tableId);
        } else {
            let items = [
                {
                    image: SuspendIcon,
                    title:
                        siteData[1].status !== "suspended"
                            ? "Suspend site"
                            : "Unsuspend site",
                },
                {
                    image: ClearLogsIcon,
                    title: "Clear logs",
                },
                {
                    image: serialIcon,
                    title: "Change serial number",
                },
                {
                    image: ChangePortalNameIcon,
                    title: "Change app site name (Global)"
                },
                {
                    image: AddToGroupIcon,
                    title: "Add to group"
                },
                {
                    image: CopyConfigIcon,
                    title: "Copy site configuration"
                }

            ];

            if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V' && _supportsCamect) {
                items.splice(4, 0, {
                    image: CamectIntegrationIcon,
                    title: "Change CCTV integration type",
                },);
            }

            if (isOnline && (DeviceType != "CC" && DeviceType != "S")) {
                items.splice(5, 0, {
                    image: RebootIcon,
                    title: "Reboot site",
                })
            }

            if (isOnline) {
                items.splice(6, 0,
                    {
                        image: ResetIcon,
                        title: "Reset site",
                    });
            }


            setModalTitle("Site config")
            setModalComponent(
                <ul style={{ listStyleType: "none", padding: 0 }}>
                    {items.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleItemClick(item)} // Pass the clicked item to the handler
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                                cursor: "pointer",
                                borderBottom: "1px solid #ddd",
                            }}
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                style={{ width: "24px", height: "24px", marginRight: "10px" }}
                            />
                            <span>{item.title}</span>
                        </li>
                    ))}
                </ul>
            )
            HandleShowModal();
        }
    }

    const HandleDeviceUserList = async () => {
        const data = await getSingleDeviceUsers(apiData, DeviceUUID, dispatch)
        setDeviceUsersList(data)
    }

    useEffect(() => {
        dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));
    }, [siteData])

    const HandleRefreshTable = () => {
        setRefreshTable(true);
    }

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        setModalComponent(<></>)
        tableNameHandler(prevTableID)
        setHasDeviceChanged(hasDeviceChanged + 1)
    }

    useEffect(() => {
        if (showChangeGroup) {
            //ShowGroupsModal();
            setAddToGroupVisible(true)
            setShowChangeGroup(false);
        }

        if (showChangeCCTV) {
            confirmModal();
            setShowChangeCCTV(false);
        }

        if (showChangeName) {
            showChangeNameModal();
            setShowChangeName(false);
        }

        if (showChangePortalName) {
            ChangeTag();
            setShowChangePortalName(false);
        }

        if (showSuspendSite) {
            suspendSite();
            setShowSuspendSite(false);
        }

        if (showChangeSerialNumber) {
            ChangeSerial()
            setShowChangeSerialNumber(false);
        }
    }, [showChangeGroup, showChangeCCTV, showChangeName, showChangePortalName, showSuspendSite, showChangeSerialNumber])

    useEffect(() => {
        const getGateways = async () => {
            const response = await getVirtualRelationshipsAPI(apiData, DeviceUUID)
            const gateways = response?.[0]?.gateways || []
            setHasGateways(gateways.length > 0)
            if (gateways.length > 0) {
                setGatewayImei(gateways[0].IMEI)
            }
        }

        getGateways();
    }, [])

    const iglooLocks = siteData[0].singleDeviceSettingData.iglooLocks

    const renderTable = (tableId) => {
        switch (tableId) {
            case 'Overview':
                return (
                    <Await resolve={siteData}>
                        {(loadedSiteData) =>
                            <Overview
                                device={loadedSiteData}
                                setShowChangeGroup={setShowChangeGroup}
                                setShowChangeCCTV={setShowChangeCCTV}
                                setShowChangeName={setShowChangeName}
                                setShowChangePortalName={setShowChangePortalName}
                                setShowSuspendSite={setShowSuspendSite}
                                setShowChangeSerialNumber={setShowChangeSerialNumber}
                                apiData={apiData}
                                supportsCamect={_supportsCamect}
                                successModal={successModal}
                                successModalWithReload={siteResetSuccessModal}
                                errorModal={errorModal}
                                userCount={userCount}
                                groups={groups}
                                isCollapsed={leftCollapsed}
                                pendingActive={pendingActive}
                                setPendingActive={setPendingActive}
                            />
                        }
                    </Await>
                )
            case 'Events':
                return (
                    <Suspense fallback={
                        <div className={classes["loadingSpinner-container"]}>
                            <div style={{ width: "100%", height: "100%", background: "white", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px" }}>
                                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                            </div>
                        </div>
                    }>
                        <Await resolve={SiteEventLogs}>
                            {(loadedDeviceEventsList) =>
                                <Logs SiteEventLogs={loadedDeviceEventsList} apiData={apiData} isCollapsed={leftCollapsed} deviceUUID={DeviceUUID}/>
                            }
                        </Await>
                    </Suspense>
                )
            case 'Users':
                return (
                    <Suspense fallback={
                        <div className={classes["loadingSpinner-container"]}>
                            <div style={{ width: "100%", height: "100%", background: "white", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px" }}>
                                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                            </div>
                        </div>
                    }>
                        <Await resolve={deviceUserList}>
                            {(loadedDeviceUserList) =>
                                <SingleDeviceUsersTableLayout 
                                    SiteDeviceUserList={loadedDeviceUserList} 
                                    setModalTitle={setModalTitle} 
                                    setModalComponent={setModalComponent} 
                                    deviceTag={deviceTag} 
                                    apiData={apiData} 
                                    deviceId={deviceId} 
                                    userID={userID} 
                                    userRole={userRole} 
                                    userEmail={userEmail} 
                                    DeviceName={DeviceName} 
                                    HandleShowModal={HandleShowModal} 
                                    HandleCloseModal={HandleCloseModal} 
                                    DeviceUUID={DeviceUUID} 
                                    companyName={companyName} 
                                    HandleDeviceUserList={HandleDeviceUserList} 
                                    scheduleOnly={scheduleOnly}
                                    liveViewEnabled={liveViewEnabled}
                                    site={[{ data: [siteData[1]] }]}
                                    isCollapsed={leftCollapsed}
                                />
                            }
                        </Await>
                    </Suspense>
                )
            case 'Rules':
                return (
                    <Suspense fallback={
                        <div className={classes["loadingSpinner-container"]}>
                            <div style={{ width: "100%", height: "100%", background: "white", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px" }}>
                                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                            </div>
                        </div>
                    }>
                        <Await resolve={RulesPreloadData}>
                            {(loadedRulesPreloadData) => {
                                const preloadedData = rulesPreloadConsumedRef.current ? null : loadedRulesPreloadData;
                                rulesPreloadConsumedRef.current = true;
                                return <Automations outputs={outputs} inputs={inputs} deviceData={siteData[0]} firmware={firmware} siteType={DeviceType} onRulesChanged={() => setUpdateLinkedto(prev => prev +1)} isCollapsed={leftCollapsed} preloadedData={preloadedData}/>
                            }}
                        </Await>
                    </Suspense>
                )
            case 'Groups':
                return <GroupsGrid />
            case 'Devices':
                return (
                    <Suspense fallback={
                        <div className={classes["loadingSpinner-container"]}>
                            <div style={{ width: "100%", height: "100%", background: "white", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px" }}>
                                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                            </div>
                        </div>
                    }>
                        <Await resolve={VirtualSourcesPreloadData}>
                            {(loadedVirtualSourcesPreloadData) => {
                                const preloadedData = virtualSourcesPreloadConsumedRef.current ? null : loadedVirtualSourcesPreloadData;
                                virtualSourcesPreloadConsumedRef.current = true;
                                return <VirtualSources iglooLocks={iglooLocks} outputs={outputs} inputs={inputs} deviceData={siteData[0]} setHasDeviceChanged={setHasDeviceChanged} DeviceDetails={siteData[1]} apiData={apiData} device={siteData} isCollapsed={leftCollapsed} preloadedData={preloadedData} siteGroupID={siteGroupID} isRESUREGroup={isRESUREGroup} />
                            }}
                        </Await>
                    </Suspense>
                )
            case 'Analytics':
                return (
                    <AnalyticsPage
                        siteUUID={DeviceUUID}
                        siteData={parsedSiteData}
                        apiData={apiData}
                        iglooLocks={siteData[0].singleDeviceSettingData.iglooLocks}
                        hasGateways={hasGateways}
                        gatewayImei={gatewayImei}
                        OutPutsPinNames={outputs}
                        isCollapsed={leftCollapsed}
                    />
                )
            default:
                return null;
        }
    }

    const deviceUUID = localStorage.getItem("DeviceUUID");
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    // Function to check window size
    const checkWindowSize = () => {
        // Set your breakpoint (e.g., 768px)
        if (window.innerWidth < 1482) {
            setIsSmallScreen(true);
        } else {
            setIsSmallScreen(false);
        }
    };

    // Add event listener on mount
    useEffect(() => {
        checkWindowSize(); // Check size on mount
        window.addEventListener('resize', checkWindowSize); // Add event listener

        // Cleanup function to remove the event listener
        return () => {
            window.removeEventListener('resize', checkWindowSize);
        };
    }, []); // Empty array ensures this runs only once on mount

    useEffect(() => {
    }, [parsedSiteData])

    const setGroupData = () => {
        const groupClicked = groups.find(g => g.name === SiteData.data[0].name);

        if (groupClicked) {
            sessionStorage.setItem('groupClicked', groupClicked.name)
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)
            navigate(`/Dashboard/Groups/GroupSites`)
        }
    }


    return (
        <>

            <CopySiteConfigForm
                apiData={apiData}
                visible={copyConfigVisible}
                setIsVisible={setCopyConfigVisible}
                siteIdentifier={deviceTag != "" && deviceTag != null ? deviceTag : uipioid}
                groups={groups}
                deviceFromUUID={DeviceUUID}
                userID={userID}
                deviceFromID={deviceId}
            />

            <Dialog
                header="Add to group"
                visible={addToGroupVisible}
                style={{ width: "40vw" }}
                onHide={() => setAddToGroupVisible(false)}
            >
                <div>
                    <p>Choose new group from the dropdown below</p>
                    <Dropdown
                        value={selectedNewGroup}
                        onChange={(e) => setSelectedNewGroup(e.value)}
                        options={groups}
                        optionLabel="name"
                        showClear
                        filter
                        placeholder="Select a group"
                        className="w-full md:w-14rem" />
                </div>

                

                <p>Or {" "}
                    <Link
                        
                        className={classes.tableValueText}
                        onClick={() => setGroupData()}
                        >{"navigate"}
                        
                    </Link> 
                    
                    {" "} to group
                </p>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button icon="pi pi-check" label="Next" severity="success" disabled={!selectedNewGroup} onClick={() => AddSiteToGroup(DeviceUUID)} />
                </div>
            </Dialog>

            <div style={{ height: "100%", width: "100%", paddingBottom: "100px" }}>
                <Modal ref={ModalDialog} title={modalTitle} modalName={"Site View"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal}>
                    {modalComponent}
                </Modal>
                <div className={classes.siteView}>
                    <div className={classes.mainView}>
                        <div className={`${classes.leftPanel} ${leftCollapsed == true ? classes.leftPanelCollapsed : ''}`}>
                            <Suspense fallback={
                                <div className={classes["loadingSpinner-container"]}>
                                    <div style={{ width: "100%", height: "100%", background: "white", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px", gap: "15px" }}>
                                        <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                                    </div>
                                </div>
                            }>
                                <Await resolve={siteData}>
                                    {(loadedSiteData) =>
                                        <>
                                            <AppView singleDevicePins={loadedSiteData[0]} deviceUUID={deviceUUID} setPinEdited={setPinEdited} firmware={firmware} setHasDeviceChanged={setHasDeviceChanged} socketPinStates={socketPinStates} siteData={parsedSiteData} setSiteData={setSiteData} linkedTo={linkedTo} setUpdateLinkedto={setUpdateLinkedto} activeHolidayModes={activeHolidayModes} pinIntegrations={pinIntegrations} schedules={schedules} todaysSchedules={parsedSiteData.data[0].todaysSchedules}/>
                                        </>
                                    }
                                </Await>
                            </Suspense>
                        </div>

                        <button className={classes.collapseButton} onClick={() => handleCollapseAppView()} title={leftCollapsed ? "Show app view" : "Hide app view"}>
                            {leftCollapsed ? '»' : '«'}
                        </button>

                        {<div className={classes.right}>
                            {leftCollapsed && (
                                <p style={{marginLeft:"0px", fontWeight:"500", fontSize:"22px", color:"#808080", marginBottom:"10px"}}>
                                    {`Site: ${portalName}`}
                                </p>)
                            }

                            <ContorlsBar style={{marginLeft:"20px"}} activeTable={activeTable} tableNameHandler={tableNameHandler} HandleRefreshTable={HandleRefreshTable} userCount={userCount}/>
                            {activeTable && renderTable(activeTable)}
                                    
                        </div>}

                    </div>
                </div>


            </div>
        </>
    )
}

export default SiteView;

// Aggregates the Rules tab's API calls into a single promise so it can be preloaded
// alongside the rest of the site data. Individual calls are caught so one flaky
// endpoint can't reject the whole tab (this route has no errorElement).
async function getRulesPreloadData(apiData, DeviceUUID) {
    const [ifTTTRules, advRulesRes, schedulesRes, holidayModesRes, accessRestrictionsRes] = await Promise.all([
        getInputRules(apiData, DeviceUUID).catch(() => null),
        getAdvRules(apiData, DeviceUUID).catch(() => null),
        getSchedules(apiData, DeviceUUID).catch(() => null),
        getHolidaysModesAPI(apiData, DeviceUUID).catch(() => null),
        getSiteAccessRestrictions(DeviceUUID, apiData).catch(() => null),
    ]);
    return { ifTTTRules, advRulesRes, schedulesRes, holidayModesRes, accessRestrictionsRes };
}

// Aggregates the Devices tab's API calls into a single promise, same reasoning as above.
async function getVirtualSourcesPreloadData(apiData, DeviceUUID, rawDevice) {
    const firmwareMajor = parseInt((rawDevice?.firmware ?? '0.0.0').split('.')[0], 10) || 0;
    const liveViewEnabled = rawDevice?.liveViewEnabled == 1;
    const deviceId = rawDevice?.id;

    const [virtualRelationshipsRes, camectsRes, integrationsRes, liveViewCamerasRes, davantisRes, supportsCamectRes, tankSensorsRes] = await Promise.all([
        getVirtualRelationshipsAPI(apiData, DeviceUUID).catch(() => null),
        getCamectsAPI(apiData, DeviceUUID).catch(() => null),
        getIntegrations(apiData, DeviceUUID).catch(() => null),
        liveViewEnabled ? getLiveViewCameras(apiData, DeviceUUID).catch(() => null) : Promise.resolve(null),
        firmwareMajor >= 3 ? getDavantisesAPI(apiData, DeviceUUID).catch(() => null) : Promise.resolve(null),
        deviceId ? checkSiteConfig(apiData, deviceId).catch(() => null) : Promise.resolve(null),
        getTankSensorsForSite(apiData, DeviceUUID).catch(() => null),
    ]);

    return { virtualRelationshipsRes, camectsRes, integrationsRes, liveViewCamerasRes, davantisRes, supportsCamectRes, tankSensorsRes, liveViewEnabled, firmwareMajor };
}

export async function loader(params) {
    // loader is a javascript function only, so gets data and header using session storage.
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const DeviceUUID = params.params.SiteID
    // Storing Device UUID to session storage for refresh purposes.
    localStorage.setItem('DeviceUUID', DeviceUUID);

    // const todayDate = new Date();
    // const todayDateString = todayDate.toISOString();

    // const thirtyDaysAgoDate = new Date()
    // thirtyDaysAgoDate.setDate(thirtyDaysAgoDate.getDate() - 30);
    // const thirtyDaysAgoDateString = thirtyDaysAgoDate.toISOString();

    const apiData = {
        token,
        client
    }

    const singleDeviceData = await getSingleDeviceData(apiData, DeviceUUID);
    const rawDevice = singleDeviceData?.data?.[0];

    return defer({
        SiteData: singleDeviceData,
        SiteDeviceUserList: getSingleDeviceUsers(apiData, DeviceUUID),
        RulesPreloadData: getRulesPreloadData(apiData, DeviceUUID),
        VirtualSourcesPreloadData: getVirtualSourcesPreloadData(apiData, DeviceUUID, rawDevice),
        // SiteEventLogs: getDeviceEventLogsRanged(apiData, DeviceUUID, thirtyDaysAgoDateString, todayDateString),
    })
}

